/* NĒM age gate. Remembers a "yes" for 30 days in a first-party cookie.
   Visibility is driven only by the `hidden` attribute; oxy-age-gate.css makes
   that attribute win over the overlays' display:flex. */
(function () {
  'use strict';

  var COOKIE_NAME = 'oxyvape_age_verified';
  var COOKIE_DAYS = 30;
  var FADE_MS = 420;

  var gate = document.getElementById('oxyvape-age-gate');
  var declined = document.getElementById('oxyvape-age-declined');
  if (!gate) return;

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 864e5);
    document.cookie =
      name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
  }

  // The inline check in the snippet already hid the gate for verified visitors.
  if (gate.hidden) {
    document.body.classList.remove('age-gate-active');
    return;
  }

  document.body.classList.add('age-gate-active');

  function accept() {
    setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
    gate.classList.add('age-gate-fadeout');
    window.setTimeout(function () {
      gate.hidden = true;
      gate.classList.remove('age-gate-fadeout');
      document.body.classList.remove('age-gate-active');
    }, FADE_MS);
  }

  function decline() {
    var denyUrl = gate.getAttribute('data-deny-url');
    gate.classList.add('age-gate-fadeout');
    window.setTimeout(function () {
      gate.hidden = true;
      gate.classList.remove('age-gate-fadeout');
      if (denyUrl) {
        window.location.href = denyUrl;
        return;
      }
      // No cookie is set on "no": the question comes back on the next visit.
      if (declined) declined.hidden = false;
    }, FADE_MS);
  }

  var acceptBtn = gate.querySelector('[data-age-gate-accept]');
  var declineBtn = gate.querySelector('[data-age-gate-decline]');
  if (acceptBtn) acceptBtn.addEventListener('click', accept);
  if (declineBtn) declineBtn.addEventListener('click', decline);

  // Keep keyboard focus inside the dialog while it is open.
  gate.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = gate.querySelectorAll('button');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (acceptBtn) acceptBtn.focus({ preventScroll: true });
})();
